"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemappingApp = void 0;
var App_1 = require("../../App");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var contexts_1 = require("../../interfaces/contexts");
var utils_1 = require("./utils");
var riskTree_1 = require("./riskTree");
var statusFilter_1 = require("./statusFilter");
var reassignUsersForm_1 = require("./reassignUsersForm");
var utils_2 = require("../../utils");
var generic_1 = require("../generic");
var ActionsControlsRisksDict = (function () {
    function ActionsControlsRisksDict(actions, controls, risks) {
        this.actions = actions || [];
        this.controls = controls || [];
        this.risks = risks || [];
    }
    ActionsControlsRisksDict.prototype.add = function (id, value) {
        if (id.indexOf('action_') > -1)
            this.actions.push(value);
        else if (id.indexOf('control_') > -1)
            this.controls.push(value);
        else if (id.indexOf('risk_') > -1)
            this.risks.push(value);
    };
    ActionsControlsRisksDict.prototype.remove = function (id, value) {
        if (id.indexOf('action_') > -1) {
            this.actions.splice(this.actions.indexOf((value)), 1);
        }
        else if (id.indexOf('control_') > -1) {
            this.controls.splice(this.controls.indexOf((value)), 1);
        }
        else if (id.indexOf('risk_') > -1) {
            this.risks.splice(this.risks.indexOf((value)), 1);
        }
    };
    ActionsControlsRisksDict.prototype.copy = function () {
        return new ActionsControlsRisksDict(this.actions.slice(), this.controls.slice(), this.risks.slice());
    };
    ActionsControlsRisksDict.prototype.clear = function () {
        this.actions = [];
        this.controls = [];
        this.risks = [];
    };
    return ActionsControlsRisksDict;
}());
function getFromUserURLParam() {
    var search = new URLSearchParams(window.location.search);
    var from_user = search.get("from_user");
    if (from_user) {
        try {
            return parseInt(from_user).toString();
        }
        catch (e) {
        }
    }
    return null;
}
var RemappingApp = (function (_super) {
    __extends(RemappingApp, _super);
    function RemappingApp(props) {
        var _this = _super.call(this, props) || this;
        _this.checkAllActionsId = "all_actions";
        _this.checkAllControlsId = "all_controls";
        _this.checkAllRisksId = "all_risks";
        _this.checkAllId = "select_all";
        _this.inputChangeHandler = function (e) {
            var targetId = e.target.id;
            var targetSelected = e.target.checked;
            var targetValue = e.target.value.toString();
            var selectedItemIds = _this.state.selectedItemIds.slice();
            var selectedValues = _this.state.selectedValues.copy();
            var checkAllRisks = _this.state.checkAllRisks;
            var checkAllControls = _this.state.checkAllControls;
            var checkAllActions = _this.state.checkAllActions;
            var selectAllBox = $("#" + _this.checkAllId).get(0);
            switch (targetId) {
                case _this.checkAllRisksId:
                    checkAllRisks = targetSelected;
                    if (targetSelected == false) {
                        selectedItemIds = selectedItemIds.filter(function (id) { return id.indexOf("risk_") == -1; });
                        selectedValues.risks = [];
                    }
                    if ((!targetSelected && selectAllBox.checked) ||
                        (targetSelected && checkAllRisks && checkAllControls && checkAllActions))
                        selectAllBox.click();
                    break;
                case _this.checkAllControlsId:
                    checkAllControls = targetSelected;
                    if (targetSelected == false) {
                        selectedItemIds = selectedItemIds.filter(function (id) { return id.indexOf("control_") == -1; });
                        selectedValues.controls = [];
                    }
                    if ((!targetSelected && selectAllBox.checked) ||
                        (targetSelected && checkAllRisks && checkAllControls && checkAllActions))
                        selectAllBox.click();
                    break;
                case _this.checkAllActionsId:
                    checkAllActions = targetSelected;
                    if (targetSelected == false) {
                        selectedItemIds = selectedItemIds.filter(function (id) { return id.indexOf("action_") == -1; });
                        selectedValues.actions = [];
                    }
                    if ((!targetSelected && selectAllBox.checked) ||
                        (targetSelected && checkAllRisks && checkAllControls && checkAllActions))
                        selectAllBox.click();
                    break;
                case _this.checkAllId:
                    checkAllRisks = targetSelected;
                    checkAllControls = targetSelected;
                    checkAllActions = targetSelected;
                    if (targetSelected == false) {
                        selectedItemIds = [];
                        selectedValues.clear();
                    }
                    break;
                default:
                    if (targetSelected && !_this.isChecked(targetId, targetValue)) {
                        selectedItemIds.push(targetId);
                        selectedValues.add(targetId, targetValue);
                    }
                    else if (!targetSelected && _this.isChecked(targetId, targetValue)) {
                        selectedItemIds.splice(selectedItemIds.indexOf(targetId), 1);
                        selectedValues.remove(targetId, targetValue);
                        if (checkAllRisks && (0, utils_1.isRiskId)(targetId)) {
                            checkAllRisks = false;
                        }
                        if (checkAllControls && (0, utils_1.isControlId)(targetId)) {
                            checkAllControls = false;
                        }
                        if (checkAllActions && (0, utils_1.isActionId)(targetId)) {
                            checkAllActions = false;
                        }
                    }
                    break;
            }
            _this.setState({
                selectedItemIds: selectedItemIds,
                selectedValues: selectedValues,
                checkAllRisks: checkAllRisks,
                checkAllControls: checkAllControls,
                checkAllActions: checkAllActions,
            });
            _this.setState({
                first_run: false
            });
        };
        function emptyStatusChoices() {
            var actionChoices = [
                {
                    display_name: gettext("Possible"),
                    value: "10"
                },
                {
                    display_name: gettext("Planned"),
                    value: "20"
                },
                {
                    display_name: gettext("Ongoing"),
                    value: "30"
                },
            ];
            var controlChoices = [
                {
                    display_name: gettext("Possible"),
                    value: "10"
                },
                {
                    display_name: gettext("Planned"),
                    value: "20"
                },
                {
                    display_name: gettext("Ongoing"),
                    value: "30"
                },
            ];
            var riskChoices = [
                {
                    display_name: gettext("New"),
                    value: "10"
                },
                {
                    display_name: gettext("Open"),
                    value: "20"
                },
            ];
            return {
                actions: actionChoices,
                controls: controlChoices,
                risks: riskChoices,
            };
        }
        _this.all_users = App_1.store.users.users.concat(App_1.store.users.past_owners);
        _this.state = {
            from_user: null,
            to_user: null,
            project_id: _this.props.project_id,
            selectedItemIds: [],
            selectedValues: new ActionsControlsRisksDict(),
            risks: [],
            checkAllActions: false,
            checkAllControls: false,
            checkAllRisks: false,
            status_choices: emptyStatusChoices(),
            statuses_to_display: emptyStatusChoices(),
            all_status_values: emptyStatusChoices(),
            first_run: true
        };
        return _this;
    }
    RemappingApp.prototype.componentWillMount = function () {
        this.fetchStatusChoices();
    };
    RemappingApp.prototype.fetchStatusChoices = function () {
        var _this = this;
        App_1.store.context.set(new contexts_1.RemappingContext(this.state.project_id, 0));
        App_1.store.ownerships.fetchStatusChoices().then(function () {
            var all_status_values = {
                actions: App_1.store.ownerships.action_status_choices.map(function (c) { return c.value; }),
                controls: App_1.store.ownerships.control_status_choices.map(function (c) { return c.value; }),
                risks: App_1.store.ownerships.risk_status_choices.map(function (c) { return c.value; }),
            };
            _this.setState({
                status_choices: {
                    actions: App_1.store.ownerships.action_status_choices,
                    controls: App_1.store.ownerships.control_status_choices,
                    risks: App_1.store.ownerships.risk_status_choices,
                },
                statuses_to_display: all_status_values,
                all_status_values: all_status_values,
            });
        });
    };
    RemappingApp.prototype.componentDidMount = function () {
        this.fromUserChangeHandler(getFromUserURLParam());
    };
    RemappingApp.prototype.fetchData = function (user_id) {
        var _this = this;
        App_1.store.ownerships.fetchOwnerships().then(function () {
            _this.setState({
                from_user: user_id,
                risks: App_1.store.ownerships.ownerships,
                selectedItemIds: [],
                selectedValues: new ActionsControlsRisksDict(),
            });
        });
    };
    RemappingApp.prototype.fromUserChangeHandler = function (user_id) {
        if (user_id) {
            var id = parseInt(user_id);
            App_1.store.context.set(new contexts_1.RemappingContext(this.state.project_id, id));
            this.fetchData(id);
            if (this.state.first_run) {
                this.setState({
                    statuses_to_display: {
                        actions: ["10", "20", "30"],
                        controls: ["10", "20", "30"],
                        risks: ["10", "20"],
                    }
                });
                this.setState({
                    first_run: false
                });
            }
        }
        else {
            this.setState({
                from_user: null,
            });
        }
    };
    RemappingApp.prototype.toUserChangeHandler = function (user_id) {
        this.setState({
            to_user: parseInt(user_id) || null,
        });
    };
    RemappingApp.prototype.handleSubmit = function (event) {
        var _this = this;
        (0, utils_2.preventDefault)(event);
        if (!this.state.to_user || !this.state.from_user) {
            notification(gettext("A user is needed"), {
                type: "error",
            });
            return;
        }
        if (this.state.selectedValues.actions.length == 0 &&
            this.state.selectedValues.controls.length == 0 &&
            this.state.selectedValues.risks.length == 0) {
            notification(gettext("No responsibilities were selected"), {
                type: "error",
            });
            return;
        }
        var postData = {
            actions: this.state.selectedValues.actions,
            controls: this.state.selectedValues.controls,
            risks: this.state.selectedValues.risks,
            from: this.state.from_user.toString(),
            to: this.state.to_user.toString(),
        };
        App_1.store.ownerships.updateOwnerships(postData).then(function () {
            _this.fetchData(_this.state.from_user);
        }, function () {
            notification(gettext("Server Error"), {
                type: "error",
            });
        });
    };
    RemappingApp.prototype.handleFilterChange = function (filter_state) {
        this.setState({
            statuses_to_display: {
                actions: filter_state.action_status_to_display,
                controls: filter_state.control_status_to_display,
                risks: filter_state.risk_status_to_display,
            }
        });
        this.setState({
            first_run: false
        });
    };
    RemappingApp.prototype.notInStatusList = function (status, list) {
        return list.indexOf(status) == -1;
    };
    RemappingApp.prototype.isRiskStatusFiltered = function (risk) {
        return this.notInStatusList(risk.risk.status, this.state.statuses_to_display.risks);
    };
    RemappingApp.prototype.isControlStatusFiltered = function (control) {
        return this.notInStatusList(control.control.status, this.state.statuses_to_display.controls);
    };
    RemappingApp.prototype.isActionStatusFiltered = function (action) {
        return this.notInStatusList(action.action.status, this.state.statuses_to_display.actions);
    };
    RemappingApp.prototype.isChecked = function (id, value, disabled) {
        disabled = disabled || false;
        var isInGroupCheck = false;
        isInGroupCheck = isInGroupCheck || ((0, utils_1.isRiskId)(id) && this.state.checkAllRisks);
        isInGroupCheck = isInGroupCheck || ((0, utils_1.isControlId)(id) && this.state.checkAllControls);
        isInGroupCheck = isInGroupCheck || ((0, utils_1.isActionId)(id) && this.state.checkAllActions);
        var isInSelected = this.state.selectedItemIds.indexOf(id) > -1;
        if (isInGroupCheck && !isInSelected) {
            this.state.selectedItemIds.push(id);
            this.state.selectedValues.add(id, value.toString());
        }
        return !disabled && (isInGroupCheck || isInSelected);
    };
    RemappingApp.prototype.render = function () {
        var topMenu = {
            risks: {
                id: this.checkAllRisksId,
                checked: this.state.checkAllRisks
            },
            controls: {
                id: this.checkAllControlsId,
                checked: this.state.checkAllControls
            },
            actions: {
                id: this.checkAllActionsId,
                checked: this.state.checkAllActions
            },
            all: {
                id: this.checkAllId
            }
        };
        var filter_counter = ((this.state.statuses_to_display.actions.length > 0 ? 1 : 0) +
            (this.state.statuses_to_display.controls.length > 0 ? 1 : 0) +
            (this.state.statuses_to_display.risks.length > 0 ? 1 : 0));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12 col-md-10 col-lg-8 col-xl-6" },
                    React.createElement(reassignUsersForm_1.ReassignUsersForm, { selected_from_user: this.state.from_user, from_users_list: this.all_users, to_users_list: App_1.store.users.users, userChangeHandlerFrom: this.fromUserChangeHandler.bind(this), userChangeHandlerTo: this.toUserChangeHandler.bind(this), handleSubmit: this.handleSubmit.bind(this) }))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("div", { className: "btn-group", role: "group", "aria-label": "Basic example" },
                        React.createElement("button", { type: "button", className: "btn btn-link pl-0", "data-toggle": "collapse", "data-target": "#collapseStatus", "aria-expanded": "false", "aria-controls": "collapseStatus" },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.filter }),
                            " ",
                            gettext("Filters"),
                            " ",
                            filter_counter > 0 && (React.createElement("span", { className: "badge badge-pill badge-primary" }, filter_counter)))))),
            React.createElement("div", { className: "row mb-2" },
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "collapseStatus" },
                    React.createElement(statusFilter_1.StatusFilter, { risk_status_choices: this.state.status_choices.risks, control_status_choices: this.state.status_choices.controls, action_status_choices: this.state.status_choices.actions, handleChangeParent: this.handleFilterChange.bind(this) }))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col" },
                    React.createElement("form", { id: "remap_form", onSubmit: this.handleSubmit },
                        React.createElement(riskTree_1.RiskTree, { ownerships: this.state.risks, key: this.state.from_user ? this.state.from_user.toString() : "", showCheckboxes: true, inputChangeHandler: this.inputChangeHandler, isChecked: this.isChecked.bind(this), filterElements: true, isRiskFilteredOut: this.isRiskStatusFiltered.bind(this), isControlFilteredOut: this.isControlStatusFiltered.bind(this), isActionFilteredOut: this.isActionStatusFiltered.bind(this), topMenu: topMenu }))))));
    };
    RemappingApp = __decorate([
        mobx_react_1.observer
    ], RemappingApp);
    return RemappingApp;
}(React.Component));
exports.RemappingApp = RemappingApp;
